import BootstrapVue from 'bootstrap-vue';

export default BootstrapVue;
